<header class="w-full shrink-0"
	style="background-image: url('/images/marble_texture_dark.png'); background-size: cover; background-position: center; height: 90px;">

	<div class="flex items-center justify-between h-full px-4">

		<!-- Left: bust + title text — taller than header, bleeds below into marble strip -->
		<img src="/images/fullLogo.png" alt="The Socrates Initiative"
			style="height: 80px; width: auto;" />

		<!-- Right: gear (admin) + profile -->
		<div class="flex items-center gap-3">

			<!-- Profile dropdown -->
			<div class="relative">
				<button (click)="toggleAccountMenu()"
					class="flex items-center gap-2 rounded px-2 py-1 transition-colors"
					style="color: var(--color-sandstone); margin-top: -10px;"
					onmouseover="this.style.backgroundColor='rgba(255,255,255,0.1)'"
					onmouseout="this.style.backgroundColor='transparent'"
					[attr.aria-expanded]="accountMenuOpen">

					<!-- Initials medallion -->
					<div class="flex items-center justify-center rounded-full shrink-0"
						style="width: 35px; height: 35px; background-color: var(--color-gold-600); border: 1px solid var(--color-gold-400);">
						<span style="font-family: var(--font-family-display); font-size: 0.75rem; font-weight: 600; color: var(--color-marble); letter-spacing: 0.05em;">
							{{ initials }}
						</span>
					</div>

					<span ro-i18n eikey="nav.account" style="font-family: var(--font-family-display); font-size: 0.7rem; letter-spacing: 0.1em; color: var(--color-sandstone);">Profile</span>

					<svg class="h-3.5 w-3.5 transition-transform" [class.rotate-180]="accountMenuOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
					</svg>
				</button>

				@if (accountMenuOpen) {
					<div class="fixed inset-0 z-40" (click)="closeAccountMenu()"></div>
					<div class="absolute right-0 z-50 mt-1 w-52 origin-top-right rounded shadow-xl"
						style="background-color: var(--color-marble); border: 1px solid var(--color-sandstone);">
						<div class="py-1">

							<div class="px-4 py-2 border-b" style="border-color: var(--color-sandstone);">
								<p style="font-family: var(--font-family-display); font-size: 0.7rem; letter-spacing: 0.08em; color: var(--color-aegean-600);">{{ fullName }}</p>
								<p style="font-family: var(--font-family-display); font-size: 0.5rem; letter-spacing: 0.08em; color: var(--color-charcoal); opacity: 0.6; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ email }}</p>
							</div>

							<button (click)="openAccountSettings()"
								class="w-full px-4 py-2 text-left transition-colors"
								style="font-family: var(--font-family-display); font-size: 0.7rem; letter-spacing: 0.08em; color: var(--color-charcoal);"
								onmouseover="this.style.backgroundColor='var(--color-sandstone)'"
								onmouseout="this.style.backgroundColor='transparent'">
								<span ro-i18n eikey="account.menu.accountSettings">Account settings</span>
							</button>


							<div style="height: 1px; background-color: var(--color-sandstone); margin: 0.25rem 0;"></div>

							<button (click)="logout()"
								class="w-full px-4 py-2 text-left transition-colors"
								style="font-family: var(--font-family-display); font-size: 0.7rem; letter-spacing: 0.08em; color: var(--color-terra-500);"
								onmouseover="this.style.backgroundColor='var(--color-sandstone)'"
								onmouseout="this.style.backgroundColor='transparent'">
								<span ro-i18n eikey="account.menu.logout">Log out</span>
							</button>

						</div>
					</div>
				}
			</div>

		</div>
	</div>

</header>
